exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"List.vue","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bfef5ecc","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/sass-resources-loader/lib/loader.js?{"resources":["/opt/build/repo/src/stylesheets/fonts.scss","/opt/build/repo/src/stylesheets/variables.scss","/opt/build/repo/src/stylesheets/mixins.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/clerkinn/sellers/List.vue
// module id = 1435
// module chunks = 30